<template>
    <div>
        <v-card class="pa-2 mb-2">
            <v-row>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mr-4" :disabled="!($global.login.administrator && $global.login.dealerGUID === 'DX')" @click="addUser"><v-icon left>mdi-content-save</v-icon>Create User</v-btn>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                        <span class="headline">User</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-checkbox v-model="editedItem.active" label="Active"></v-checkbox>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-checkbox v-model="editedItem.administrator" label="Administrator"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field v-model="editedItem.firmGUID" label="Firm" :disabled="!($global.login.administrator && $global.login.dealerGUID === 'DX')"></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-select v-model="editedItem.userTypeGUID" :items="types" item-text="type" item-value="userTypeGUID" label="Type" :disabled="!($global.login.administrator && $global.login.dealerGUID === 'DX')"></v-select>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-select v-model="editedItem.dealerGUID" :items="dealers" item-text="dealer" item-value="dealerGUID" label="Dealer" :disabled="!($global.login.administrator && $global.login.dealerGUID === 'DX')"></v-select>
                                        </v-col>
                                    </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="resetDialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                        <span class="headline">Reset Password</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                    <v-row>
                                        <v-col>
                                            <v-text-field v-model="editedItem.password" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" label="Password" counter @click:append="showPassword = !showPassword"></v-text-field>
                                        </v-col>
                                    </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="resetClose">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="resetPassword">Reset</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-card>

        <v-card class="mb-2">
            <v-card-title class="pa-2">
                <v-row>
                    <v-col>
                        <label><v-icon left>mdi-magnify</v-icon>Search</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field ref="searchFor" label="Email or Name" prepend-inner-icon="mdi-magnify" v-model="searchFor" outlined dense single-line rounded clearable hide-details @keyup.native="onKey"></v-text-field>
                    </v-col>
                    <v-col>
                        <v-btn color="primary" class="ml-4" @click="confirmLoadUsers"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <v-card>
            <v-card-title class="pa-2">
                <v-row>
                    <v-col>
                        <label><v-icon left>mdi-account</v-icon>Users</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="table.search" label="Filter on any field" prepend-inner-icon="mdi-filter-outline" outlined dense single-line rounded clearable hide-details v-show="table.users.length > 0"></v-text-field>
                    </v-col>
                    <v-col>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-data-table dense :footer-props="table.footerProps" v-model="table.selected" item-key="user" :headers="table.headers" :items="table.users" :search="table.search" :loading="isBusy" :loading-text="table.loadingText" class="elevation-1">
                <template v-slot:[`item.active`]="{ item }">
                    <v-badge inline :color="getActiveColor(item.active)" dot></v-badge>
                </template>
                <template v-slot:[`item.administrator`]="{ item }">
                    <v-badge inline :color="getActiveColor(item.administrator)" dot></v-badge>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <v-icon :disabled="!$global.login.administrator" small @click="editUser(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon :disabled="!$global.login.administrator && ($global.login.email != item.email)" small @click="confirmResetPassword(item)">
                        mdi-key
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>

export default {
    name: "UserManager",
    data() {
        return {
            singleSelect: false,
            title: "Users",
            isBusy: false,
            searching: true,
            dialog: false,
            resetDialog: false,
            showPassword: false,
            editingUser: {
                active: 0,
            },
            searchFor: "",
            table: {
                selected: [],
                footerProps: { "items-per-page-options": [15, 25, 50, 100] },
                search: "",
                itemKey: "userGUID",
                loadingText: "loading users",
                headers: [
                    {
                        text: "Active", value: "active", width: "86px",
                    },
                    { text: "Type", value: "userTypeGUID" },
                    { text: "Admin", value: "administrator" },
                    { text: "Dealer", value: "dealerGUID" },
                    { text: "Firm", value: "firmGUID" },
                    { text: "Email", value: "email" },
                    { text: "Name", value: "name" },
                    { text: "Actions", value: "action", sortable: false },
                ],
                users: [],
            },
            editedIndex: -1,
            editedItem: {
                userTypeGUID: "DX",
                dealerGUID: "DX",
                firmGUID: "",
                administrator: "",
                email: "",
                name: "",
                active: 1,
            },
            defaultItem: {
                userTypeGUID: "DX",
                dealerGUID: "DX",
                firmGUID: "",
                administrator: "",
                email: "",
                name: "",
                active: 1,
            },
            types: [{ userTypeGUID: "DX", type: "Draftworx" }, { userTypeGUID: "CLIENT", type: "Client" }, { userTypeGUID: "RESELLER", type: "Reseller" }],
            dealers: [],
        };
    },
    mounted() {
        this.searchDealers();
    },
    methods: {
        onKey(evt) {
            if (evt.key === "Enter") {
                this.confirmLoadUsers();
            }
        },
        onBackKey() {
            this.searching = true;
        },
        confirmLoadUsers() {
            if (this.searchFor === null) {
                this.searchFor = "";
            }
            if (this.searchFor === "") {
                this.$confirm({
                    title: "Confirm Search",
                    message: "Are you sure you wish to load the first 1000 users?",
                }, (value) => {
                    if (value) {
                        this.loadUsers();
                    }
                });
            }
            else {
                this.loadUsers();
            }
        },
        loadUsers() {
            this.isBusy = true;
            this.table.users = [];
            this.table.selected = [];
            this.$http
                .get(`/api/user/search/${this.searchFor}/`)
                .then((response) => {
                    this.table.users = response.data;
                    this.isBusy = false;

                    this.$ga.event({
                        eventCategory: "users",
                        eventAction: "search",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err });
                    }
                });
        },
        getActiveColor(active) {
            if (active === true) return "green";
            return "red";
        },
        getActiveIcon(active) {
            if (active === true) return "mdi-checkbox-marked-circle-outline";
            return "mdi-checkbox-blank-circle-outline";
        },
        addUser() {
            this.editedIndex = -1;
            this.editedItem = Object.assign({}, this.defaultItem);
            this.dialog = true;
        },
        editUser(item) {
            this.editedIndex = this.table.users.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        confirmResetPassword(item) {
            this.editedIndex = this.table.users.indexOf(item);
            this.editedItem = this.table.users[this.editedIndex];

            this.$confirm({
                title: "Confirm Reset",
                message: "Are you sure you wish to reset this user's password?",
            }, (value) => {
                if (value) {
                    this.editedItem.password = "";
                    this.resetDialog = true;
                }
            });
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },
        save() {
            if (this.editedIndex > -1) {
                this.saveExistingUser();
            }
            else {
                this.saveNewUser();
            }
        },
        saveNewUser() {
            if (this.editedItem.email === "") {
                return;
            }
            this.isBusy = true;
            this.$http
                .post(`/api/user/create`, {
                    applicationGUID: this.$global.application,
                    userTypeGUID: this.editedItem.userTypeGUID,
                    dealerGUID: this.editedItem.dealerGUID,
                    firmGUID: this.editedItem.firmGUID,
                    administrator: this.editedItem.administrator,
                    email: this.editedItem.email,
                    name: this.editedItem.name,
                    active: this.editedItem.active,
                })
                .then((response) => {
                    debugger;
                    this.isBusy = false;
                    this.editedItem.userGUID = response.data;
                    this.table.users.unshift(this.editedItem);
                    this.dialog = false;

                    this.$ga.event({
                        eventCategory: "users",
                        eventAction: "create",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Create Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        saveExistingUser() {
            this.isBusy = true;
            this.$http
                .post(`/api/user/update`, {
                    applicationGUID: this.$global.application,
                    userGUID: this.editedItem.userGUID,
                    userTypeGUID: this.editedItem.userTypeGUID,
                    dealerGUID: this.editedItem.dealerGUID,
                    firmGUID: this.editedItem.firmGUID,
                    administrator: this.editedItem.administrator,
                    email: this.editedItem.email,
                    name: this.editedItem.name,
                    active: this.editedItem.active,
                })
                .then(() => {
                    this.isBusy = false;
                    Object.assign(this.table.users[this.editedIndex], this.editedItem);
                    this.dialog = false;

                    this.$ga.event({
                        eventCategory: "users",
                        eventAction: "update",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Save Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        resetClose() {
            this.resetDialog = false;
        },
        resetPassword() {
            if (this.editedItem.password === "") {
                return;
            }

            this.isBusy = true;
            this.$http
                .post(`/api/user/password_reset`, {
                    application: this.$global.application,
                    userGUID: this.editedItem.userGUID,
                    dealerGUID: this.editedItem.dealerGUID,
                    firmGUID: this.editedItem.firmGUID,
                    email: this.editedItem.email,
                    password: this.editedItem.password,
                })
                .then(() => {
                    this.resetDialog = false;
                    this.isBusy = false;

                    this.$ga.event({
                        eventCategory: "users",
                        eventAction: "password.reset",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Reset Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        searchDealers() {
            this.isBusy = true;
            this.$http
                .get(`/api/dealer/list/`)
                .then((response) => {
                    this.dealers = response.data;
                    this.isBusy = false;
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
    },
};
</script>
